// Used in situations where support info from server can't or shouldn't be used.
export const logoutUrls = {
  'base': '/',
  'local': 'https://local.climate.com/static/auth-pages/',
  'prodDefault': 'https://climate.com'
};
